'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Align = require('./Align');

var _Align2 = _interopRequireDefault(_Align);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _Align2['default']; // export this package's api

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-align/lib/index.js
 ** module id = 846
 ** module chunks = 0
 **/